// ─── Urgency Color Palette ──────────────────────────────────────────────
// Progress bar gradient colors (bright)
export const URGENCY_GREEN = '#70F20C'
export const URGENCY_AMBER = '#F7B900'
export const URGENCY_RED = '#F90707'

// Tile background colors (light pastel)
export const URGENCY_BG_GREEN = '#D4F9B0'
export const URGENCY_BG_AMBER = '#FDEAAB'
export const URGENCY_BG_RED = '#FDCACA'

// Tile font colors (darker shade)
export const URGENCY_FONT_GREEN = '#4DA009'
export const URGENCY_FONT_AMBER = '#C49300'
export const URGENCY_FONT_RED = '#D10606'

// Done + overdue background
export const DONE_OVERDUE_BG = '#FC99A3'

// ─── Urgency Calculation ────────────────────────────────────────────────

/**
 * Calculates urgency (0–100) based on remaining time until due date.
 *
 *  60+ days remaining → 0   (no urgency)
 *  30–60 days         → 0–25
 *  14–30 days         → 25–50
 *   7–14 days         → 50–75
 *   0–7  days         → 75–100
 *  overdue            → 100
 */
export const calculateUrgency = (dueDate: string | Date): number => {
  const due = dueDate instanceof Date ? dueDate.getTime() : new Date(dueDate).getTime()
  const now = Date.now()

  if (isNaN(due)) return 0

  const remainingMs = due - now
  if (remainingMs <= 0) return 100

  const remainingDays = remainingMs / (1000 * 60 * 60 * 24)

  if (remainingDays >= 60) return 0
  if (remainingDays >= 30) return ((60 - remainingDays) / 30) * 25
  if (remainingDays >= 14) return 25 + ((30 - remainingDays) / 16) * 25
  if (remainingDays >= 7) return 50 + ((14 - remainingDays) / 7) * 25
  return 75 + ((7 - remainingDays) / 7) * 25
}

// ─── Color Resolvers ────────────────────────────────────────────────────

export const getUrgencyBgColor = (urgency: number): string => {
  if (urgency <= 33) return URGENCY_BG_GREEN
  if (urgency <= 67) return URGENCY_BG_AMBER
  return URGENCY_BG_RED
}

export const getUrgencyFontColor = (urgency: number): string => {
  if (urgency <= 33) return URGENCY_FONT_GREEN
  if (urgency <= 67) return URGENCY_FONT_AMBER
  return URGENCY_FONT_RED
}

// ─── Convenience helpers (accept raw card fields) ───────────────────────

export const getDueDateBlockColor = (createdAt: string, dueDate: string, dueTime: string): string => {
  if (!createdAt || !dueDate || !dueTime) return URGENCY_BG_GREEN
  return getUrgencyBgColor(calculateUrgency(`${dueDate}T${dueTime}Z`))
}

export const getDueDateFontColor = (createdAt: string, dueDate: string, dueTime: string): string => {
  if (!createdAt || !dueDate || !dueTime) return URGENCY_FONT_GREEN
  return getUrgencyFontColor(calculateUrgency(`${dueDate}T${dueTime}Z`))
}
